<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </v-dialog>
</template>

<script>
export default {
  name: "AppDialog"
};
</script>
